import { render, staticRenderFns } from "./SvgIcon.vue?vue&type=template&id=79ce59f0&scoped=true&"
import script from "./SvgIcon.vue?vue&type=script&lang=js&"
export * from "./SvgIcon.vue?vue&type=script&lang=js&"
import style0 from "./SvgIcon.vue?vue&type=style&index=0&id=79ce59f0&prod&lang=less&"
import style1 from "./SvgIcon.vue?vue&type=style&index=1&id=79ce59f0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../.yarn/__virtual__/vue-loader-virtual-783d792af9/0/cache/vue-loader-npm-15.10.0-778eb54c35-1bf6c9ffea.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ce59f0",
  null
  
)

export default component.exports